import React from 'react';
import { Card, FormCell, Grid, BodyText } from 'ui-toolkit';
import { IVendorOrderInformationData } from '../../types/vendorDashboard/IVendorOrderInformation';
import { IVendorPayoffInformationData } from '../../types/vendorDashboard/IVendorPayoffInformation';
import { IVendorTaxCertificationInformationData } from '../../types/vendorDashboard/IVendorTaxCertificationInformation';
import { SecondaryText } from './styledComponents/SecondaryText';
import { DisplayTransactionCategory, eTransactionCategory } from 'ui-toolkit/enums/eTransactionType';
import { addressDataToString } from '../../ui-toolkit/orders/interfaces/IAddressResponse';

interface IOrderDetailsProps {
  order: IVendorOrderInformationData | IVendorPayoffInformationData | IVendorTaxCertificationInformationData;
}
export const OrderDetails: React.FC<IOrderDetailsProps> = ({ order }) => {
  return (
    <Card title={'Order Details'}>
      <Grid columnCount={2}>
        <FormCell label={'Transaction Category'} wrapInput={false}>
          <SecondaryText>{DisplayTransactionCategory[order.transactionCategory]}</SecondaryText>
        </FormCell>
        <FormCell label={'Lender'} wrapInput={false}>
          <BodyText>{order.lenderCompanyName}</BodyText>
        </FormCell>
        <FormCell label={'Property Address'} wrapInput={false}>
          <BodyText>{addressDataToString(order.address)}</BodyText>
        </FormCell>
        <FormCell label={'Client'} wrapInput={false}>
          <BodyText>{order.clientCompanyName}</BodyText>
        </FormCell>
        <FormCell label={'County'} wrapInput={false}>
          <BodyText>{order.address.countyName}</BodyText>
        </FormCell>
        <FormCell
          label={order.transactionCategory === eTransactionCategory.Purchase ? 'Buyer(s)' : 'Borrower(s)'}
          wrapInput={false}
        >
          <BodyText>{order.borrowers}</BodyText>
        </FormCell>
        <FormCell label={''} wrapInput={false}>
          <BodyText />
        </FormCell>
        <FormCell
          label={order.transactionCategory === eTransactionCategory.Purchase ? 'Seller(s)' : ''}
          wrapInput={false}
        >
          <BodyText>{order.transactionCategory === eTransactionCategory.Purchase ? order.sellers : ''}</BodyText>
        </FormCell>
      </Grid>
    </Card>
  );
};
